import React from 'react';
import styled from 'styled-components';

import { useImg, useText } from 'hooks';
import { FROM_TABLET, MOBILE, TABLET } from 'helpers/styles/media';
import { ChangeableBackgroundSection } from 'helpers/components';

const Header = () => {
  const globalNav = [
    useText('link_nav_item1', true),
    useText('link_nav_item2', true),
    useText('link_nav_item3', true),
    useText('link_nav_item4', true),
    useText('link_nav_item5', true),
    useText('link_nav_item6', true),
    useText('link_nav_item7', true),
  ];

  const mainNavBar = [
    useText('link_main_nav_item1', true),
    useText('link_main_nav_item2', true),
    useText('link_main_nav_item3', true),
    useText('link_main_nav_item4', true),
    useText('link_main_nav_item5', true),
    useText('link_main_nav_item6', true),
    useText('link_main_nav_item7', true),
    useText('link_main_nav_item8', true),
    useText('link_main_nav_item9', true),
  ];

  return (
    <ChangeableBackgroundSection
      id="header-wrapper-bg"
      defaultStyle={{ background: 'transparent' }}
    >
      <GlobalNavigationItem>
        <NavContainer>
          <Left>
            {useImg('user.svg', 'user')}
            {useText('link_nav_item_l', true)}
          </Left>
          <Main>
            {globalNav.map((el, index) => {
              return (
                <React.Fragment key={index}>{el}</React.Fragment>
              );
            })}
          </Main>
          <Right>
            {useImg('search.svg', 'search')}
            {useText('link_nav_item_r', true)}
          </Right>
        </NavContainer>
      </GlobalNavigationItem>
      <ChangeableBackgroundSection
        id="header-main-wrapper-bg"
        defaultStyle={{ background: '#b80000' }}
      >
        <Wrapper>
          <ContentWrapper>{useText('link_news', true)}</ContentWrapper>
          <BurgerMenuMob>
            {useImg('burger.svg', 'burger')}
            {useText('link_main_nav_item_mob', true)}
          </BurgerMenuMob>
          <MainNavBarContainer>
            <WrapMainBar>
              <MainBar>
                {mainNavBar.map((el, index) => {
                  return (
                    <React.Fragment key={index}>{el}</React.Fragment>
                  );
                })}
              </MainBar>
              <BurgerMenu>
                {useImg('burger.svg', 'burger')}
                {useText('link_main_nav_item_r', true)}
              </BurgerMenu>
            </WrapMainBar>
          </MainNavBarContainer>
        </Wrapper>
      </ChangeableBackgroundSection>
      <MenuContainer>
        <Text>{useText('link_text', true)}</Text>
      </MenuContainer>
    </ChangeableBackgroundSection>
  );
};

const GlobalNavigationItem = styled.div`
  padding-block: 16px;

  a {
    color: #000;
  }

  @media ${MOBILE} {
    padding: 0 40px;
  }
`;

const NavContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  font-size: 14px;

  @media ${TABLET} {
    padding: 0 30px;
  }

  @media ${MOBILE} {
    justify-content: space-between;
  }
`;

const Left = styled.div`
  cursor: pointer;
  text-decoration: none;
  width: 250px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  font-weight: 700;

  a {
    text-decoration: none;
    color: #000;
  }

  @media ${TABLET} {
    width: auto;
    margin-right: 30px;
  }

  @media ${MOBILE} {
    width: auto;
    margin: 0;
    padding: 0;

    img {
      width: 32px;
      height: 32px;
    }

    div:last-child {
      display: none;
    }
  }
`;

const Main = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;

  a {
    padding-bottom: 6px;
    border-bottom: 2px solid transparent;
    text-decoration: none;
    font-weight: 700;
  }

  a:hover {
    border-bottom: 2px solid black;
  }

  @media ${TABLET} {
    justify-content: center;
    gap: 20px;
  }

  @media ${MOBILE} {
    display: none;
  }
`;

const Right = styled.div`
  cursor: pointer;
  text-decoration: none;
  width: 200px;
  margin: 0 auto;
  margin-left: 100px;
  height: 40px;
  background-color: #ebebeb;
  padding: 12px 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;

  a {
    text-decoration: none;
    color: #000;
  }

  img {
    padding-top: 5px;
  }

  @media ${TABLET} {
    margin-left: 30px;
    width: auto;
  }

  @media ${MOBILE} {
    background: #fff;
    width: auto;
    margin: 0;
    padding: 0;

    img {
      width: 32px;
      height: 32px;
      padding: 0;
    }

    div:last-child {
      display: none;
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media ${TABLET} {
    max-width: 1200px;
  }

  @media ${MOBILE} {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 20px;
  }
`;

const ContentWrapper = styled.div`
  font-family: inherit;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  color: #fff;
  font-size: 35px;
  line-height: 1;
  font-weight: 700;
  padding-block: 16px;
  cursor: pointer;

  a {
    text-decoration: none;
    color: #fff;
  }

  @media ${TABLET} {
    padding: 16px 30px;
  }
`;

const BurgerMenuMob = styled.div`
  @media ${FROM_TABLET} {
    display: none;
  }

  display: flex;
  gap: 6px;
  cursor: pointer;
  border: 1px solid #db7f7f;
  padding: 8px;
  color: #fff;
  font-size: 20px;

  img {
    width: 30px;
    min-width: 20px;
    height: 100%;
  }

  a {
    text-decoration: none;
    color: #fff;
  }
`;

const MainNavBarContainer = styled.div`
  border-top: 1px solid #db7f7f;

  @media ${TABLET} {
    padding: 0 30px;
  }

  @media ${MOBILE} {
    display: none;
  }
`;

const WrapMainBar = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  color: #fff;
`;

const MainBar = styled.div`
  display: flex;
  flex: 1;

  a {
    position: relative;
    display: inline-block;
    color: #fff;
    padding: 11px 10px;
    font-size: 16px;
    font-weight: 400;
    text-decoration: none;
    border-bottom: 4px solid transparent;

    &::after {
      content: '';
      position: absolute;
      top: 11px;
      right: 0;
      width: 1px;
      height: 50%;
      background-color: #db7f7f;
    }

    :hover {
      border-bottom: 4px solid #fff;
    }
  }

  div:last-child {
    a {
      ::after {
        display: none;
      }
    }
  }


  div:nth-child(7) a {
    border-bottom: 4px solid #fff;
  }
`;

const BurgerMenu = styled.div`
  display: flex;
  gap: 6px;
  cursor: pointer;

  img {
    width: 20px;
  }

  a {
    text-decoration: none;
    color: #fff;
  }
`;

const MenuContainer = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;

  a {
    text-decoration: none;
    color: #000;
  }

  @media ${TABLET} {
    padding: 0 30px;
  }

  @media ${MOBILE} {
    padding-left: 20px;
  }
`;

const Text = styled.div`
  color: #141414;
  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  padding: 11px 7px;
  width: fit-content;
  border-bottom: 4px solid #b80000;
`;

export default Header;
